export default "__VITE_ASSET__BzcwThXL__"